/**
 * Created by sunshine on 2016/12/14.
 */
import Vue from 'vue'
import VueResource from 'vue-resource'
import agreement from './agreement.vue'
// Resource
Vue.use(VueResource)
new Vue({
  el: '#app',
  template: '<agreement/>',
  components: {agreement}
})



// WEBPACK FOOTER //
// ./src/pages/agreement/index.js